import React, { useRef, useImperativeHandle, forwardRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Tooltip,
  Legend,
  ZoomAndPan,
  Crosshair,
  Size,
  Point,
  CommonSeriesSettings,
  Label,
  HorizontalLine,
  VerticalLine,
} from "devextreme-react/chart";

const customizeTooltip = (info) => ({
  text: `${info.seriesName}: ${info.valueText}`,
});

const customizeArgumentAxisLabel = (info) => {
  return info.valueText;
};

const SerialTimeGraphics = forwardRef(({ data, series }, ref) => {
  const chartRef = useRef(null);

  useImperativeHandle(ref, () => ({
    zoomOut: () => {
      if (chartRef.current) {
        chartRef.current.instance().resetVisualRange();
      }
    },
  }));

  // const getTitle = () => {
  //   if (series.lenght) return `${series[0].unit}`;
  // };

  const customizeCrossHairLabel = (info) => {
    return `${info.valueText} ${series[0].unit}`;
  };

  return (
    <Chart id="chart" ref={chartRef} dataSource={data}>
      <CommonSeriesSettings
        argumentField="date"
        type="line"
        hoverMode="onlyPoint"
      />

      {series.map((serie) => (
        <Series
          key={serie.name}
          valueField={serie.name}
          name={serie.name + " " + serie.unit}
          width={1.5}
          hoverStyle={{ width: 1.5 }}
        >
          <Point size={5} hoverStyle={{ size: 3 }} />
        </Series>
      ))}

      <Size height={300} />

      <ZoomAndPan
        dragToZoom={true}
        allowMouseWheel={false}
        valueAxis="both"
        argumentAxis="both"
        panKey="shift"
      />

      <Legend
        visible={true}
        orientation="horizontal"
        position="outside"
        itemTextPosition="right"
        horizontalAlignment="center"
        verticalAlignment="top"
        hoverMode="none"
      />

      <ArgumentAxis
        aggregationGroupWidth={1}
        argumentType="datetime"
        axisDivisionFactor={100}
      >
        <Label customizeText={customizeArgumentAxisLabel} />
      </ArgumentAxis>

      {/* <ValueAxis title={getTitle()} /> */}

      <Tooltip enabled={true} customizeTooltip={customizeTooltip} />

      <Crosshair enabled={true}>
        <Label
          backgroundColor="rgb(21, 91, 140)"
          visible={true}
          customizeText={customizeCrossHairLabel}
        />
        <HorizontalLine color="rgb(21, 91, 140)" opacity={0.4} />
        <VerticalLine color="rgb(21, 91, 140)" opacity={0.4} />
      </Crosshair>
    </Chart>
  );
});

export default SerialTimeGraphics;
